import React from "react";
import { useI18n } from "../../lib/i18n.jsx";

const LOGO_TRANSPARENT = "https://i.imgur.com/27IUlf9.png";

export default function Navigation({ onOpenFlora, onOpenQuote, onOpenDistribuye, onOpenRegistro }) {
  const { lang, setLang, t } = useI18n();

  const navItems = [
    { href: "#productos", label: t.nav.products, testid: "nav-products" },
    { href: "#historia", label: t.nav.historia, testid: "nav-historia" },
    { href: "#flora", label: t.nav.flora, testid: "nav-flora" },
    { href: "#contacto", label: t.nav.contact, testid: "nav-contact" },
  ];

  return (
    <header
      className="fixed top-0 inset-x-0 z-50 eu-nav-blur"
      data-testid="site-navigation"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-24 flex items-center justify-between gap-6">
        <a
          href="#top"
          className="flex items-center gap-2"
          data-testid="nav-logo"
        >
          <img
            src={LOGO_TRANSPARENT}
            alt="Euzerone"
            className="h-14 sm:h-16 w-auto"
          />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={item.testid}
              className="text-sm font-medium text-[#1c1c1c] hover:text-[#133322] transition-colors relative group"
            >
              {item.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-[#133322] group-hover:w-full transition-all duration-300" />
            </a>
          ))}
          <button
            onClick={onOpenDistribuye}
            data-testid="nav-distribuye"
            className="text-sm font-medium text-[#1c1c1c] hover:text-[#133322] transition-colors relative group"
          >
            Distribuye
            <span className="absolute -bottom-1 left-0 h-px w-0 bg-[#133322] group-hover:w-full transition-all duration-300" />
          </button>
          <button
            onClick={onOpenRegistro}
            data-testid="nav-registro"
            className="text-sm font-medium text-[#b45f3e] hover:text-[#133322] transition-colors relative group"
          >
            Regístrate
            <span className="absolute -bottom-1 left-0 h-px w-0 bg-[#b45f3e] group-hover:w-full transition-all duration-300" />
          </button>
        </nav>

        <div className="flex items-center gap-3">
          <div
            className="hidden sm:flex items-center gap-1 text-xs font-mono-eu tracking-wider"
            data-testid="lang-switcher"
          >
            <button
              onClick={() => setLang("es")}
              className={`px-2 py-1 rounded-full transition ${
                lang === "es"
                  ? "bg-[#133322] text-[#f7f7f4]"
                  : "text-[#5c6b61] hover:text-[#133322]"
              }`}
              data-testid="lang-es"
            >
              ES
            </button>
            <span className="text-[#9ead9b]">/</span>
            <button
              onClick={() => setLang("en")}
              className={`px-2 py-1 rounded-full transition ${
                lang === "en"
                  ? "bg-[#133322] text-[#f7f7f4]"
                  : "text-[#5c6b61] hover:text-[#133322]"
              }`}
              data-testid="lang-en"
            >
              EN
            </button>
          </div>
          <button
            onClick={onOpenQuote}
            className="hidden lg:inline-flex eu-btn-primary text-sm"
            data-testid="nav-quote-btn"
          >
            <i className="fa-solid fa-leaf text-xs"></i>
            {t.nav.quote}
          </button>
        </div>
      </div>
    </header>
  );
}
